module.exports = __webpack_public_path__ + "assets/images/56d70f17d79a128bb28d2f7896874b1a.png";